import axios from "@/utils/api.request"
/**
 * 通用结果处理
 * @param {*} res
 */
 function callBack(res) {
  const { data, status } = res
  try {
    const { flag, data: response, message } = data
    // 操作成功（返回数据）
    if (flag) {
      return response
    }
    // 操作失败
    throw message
  } catch (error) {
    console.error(status)
    throw error
  }
}

/**
 * @api
 * 查询分页列表
 */
 export async function querySystemLogPageList(current = 1, size = 10, value) {
  // 构造data
  const data = { current, size }
  if (value) {
    Object.assign(data, value)
  }
  // 请求
  return axios.request({
    url: 'systemLog/querySystemLogPageList',
    data,
    method: 'post'
  }).then(callBack)
}

/**
 * 根据文件类型统计文件下载次数
 * @param data
 * @returns {Promise<AxiosResponse<any>>}
 */
export async function downloadStaByFileType(data){
    // 请求
    return axios.request({
        url: 'downloadLog/queryList',
        data,
        method: 'post'
    }).then(callBack)

}




